import { render, staticRenderFns } from "./IntegrationProviderRedirect.vue?vue&type=template&id=efa9b72e"
import script from "./IntegrationProviderRedirect.vue?vue&type=script&lang=ts"
export * from "./IntegrationProviderRedirect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports